import React, { useState, useEffect } from "react";
import CompanySearch from "../../../../components/common/forms/CompanySearch";
import DetailsOfShareHolders from "../../../../components/common/forms/DetailsOfShareHolders";
import FormBranch from "../../../../components/common/forms/FormBranch";
import FormButtom from "../../../../components/common/forms/FormButtom";
import FormOtherDetails from "../../../../components/common/forms/FormOtherDetails";
import FormUploadDocument from "../../../../components/common/forms/FormUploadDocument";
import MainObjectives from "../../../../components/common/forms/MainObjectives";
import {
  Pan_Registration_v2,
  Pan_Registration_v3,
  Pan_Registration_v5,
  Vat_upload_details_v2,
  pan_shareholder,
  Pan_Reg_details_of_shareholder,
} from "../VatRegistrationForm";
import { useForm } from "react-hook-form";
import PrivateCompanyModal from "../../../../components/common/modal/CompanyFeeModal";
import { v4 as uuidv4 } from "uuid";
import Documents from "../../../../components/common/forms/Documents";
import FormPayment from "../../../../components/common/forms/FormPayment";
import api from "../../../../api/api";
import { toast } from "react-toastify";
import AdminSearchCustomer from "../../common/AdminSearchCustomer";
import { useSelector } from "react-redux";

const VatRegistrationA = () => {
  const { register, handleSubmit } = useForm();
  const [docsOutput, setDocsOutput] = useState([]);

  const [uploadProof, setUploadProof] = useState("");

  const [shareHolders, setShareHolders] = useState([
    {
      ...pan_shareholder,
      id: uuidv4(),
    },
  ]);

  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null);
  
  const [paymentRangeList, setPaymentList] = useState([]);
  const [amount, setAmount] = useState(0);
  const [dueAmount, setDueAmount] = useState(null);
  const [paidAmount, setPaidAmount] = useState(null);

  const [registrationNature, setRegistrationNature]  = useState(null)



    // For amount calculation
    // useEffect(() => {
    //   if (amount > 0) {
    //     let arr = paymentRangeList.filter((item) => {
    //       return (
    //         amount >= parseInt(item.range_start) &&
    //         amount <= parseInt(item.range_end)
    //       );
    //     });
    //     console.log(arr);
  
    //     arr.length > 0 && setTotalAmount(arr[0]?.amount);
    //   } else {
    //     setTotalAmount(0);
    //   }
    // }, [amount, paymentRangeList]);


    useEffect(() => {

        if(registrationNature) {
           let arr = paymentRangeList.filter((item)=> {
           return item.registration_nature === registrationNature
          })
          // console.log(arr)
          setAmount(arr[0].amount)
        }      

    }, [registrationNature])
    



      //  getting current user
   useEffect(() => {
    api
      .get("/users/me/")
      .then((response) => {
        setDueAmount(response.due_amount);
      })
      .catch((error) => {});
  }, []);


     // for filtering by company_type and show in Modal
     useEffect(() => {
      api.get('/services/company/registration/service-charges/?company_type=pan_vat_gharelu_ward')
      .then(response=> {
          // console.log(response.data)
          setPaymentList(response.data)
      }).catch(error=> {
         console.log(error)
      })
    }, [])




  const handleClick = (data) => {
    data.company_type = "pan_vat_gharelu_ward";
    data.share_holders = shareHolders;
    data.documents = docsOutput;
    // console.log(data)
    if (user?.user_type === "CL") {
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    } else {
      if (userID !== null) {
        data.user = userID;
      }
    }

    api
      .post("/services/company/", data)
      .then((response) => {
        toast.success("Data Registered successfully");
        let transactions = {
          // payment_mode: "e_wallet",
          amount: 2500,
          service_object_id: response.data.registration_id,
          created_by: response.data.registration_id,
          service_object_content_type: response.data.service_content_type_id,
          payment_proof: uploadProof,
          company: response.data.company_id,
          transaction_type: "credit",
        };

        api
          .post("/transactions/", transactions)
          .then((response) => {
            toast.success("Data Registered 2 Successfully.");
          })
          .catch((error) => {
            toast.error("Error in Transaction");
          });
      })
      .catch((error) => {
        toast.error("Data Registration Failed");
      });
  };
  let data = [];
  Vat_upload_details_v2.map((item, i) => {
    data.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
  });

  return (
    <form action="">
      <div className="mt-3">
        {(user?.user_type === "ST" || user?.user_type === "AD") && (
          <AdminSearchCustomer setUserId={setUserId} />
        )}
      </div>
      <div className="flex justify-between my-3">
        <p className="text-primary-blue font-Calistoga text-lg underline">
          1. Business Name & Other Details
        </p>
        <p className="text-primary-red flex">
          Firm No.
          <span className=" text-primary-blue"> 1234</span>
        </p>
      </div>
      <CompanySearch register={register} />
      <div className="flex flex-wrap w-full">
        <div className="w-full border-2 border-primary-blue mt-3 font-Laila ">
          <div className="flex md:flex-row   flex-col">
            <div className="border-primary-blue text-center border-r text-primary-red border-b px-10 py-2 md:w-[30rem]  text-lg font-bold">
              कम्पनीको नाम
            </div>

            <div className="border-primary-blue flex text-primary-red md:border-r border-b pl-3  py-2 w-full text-base font-bold sm:text-lg">
              <p>नेपालीमा: </p>
              <input
                className="outline-none w-40 text-primary-blue pl-3 "
                {...register(`company_name_nep`, {
                  // required: false,
                })}
              />
            </div>
            <div className="border-primary-blue flex text-primary-red border-b px-3 py-2 w-full text-base font-bold sm:text-lg">
              <p>English मा: </p>
              <input
                className="outline-none text-primary-blue w-36 pl-3 "
                {...register(`company_name`, {
                  // required: false,
                })}
              />
            </div>
          </div>
          <div className="flex flex-col md:flex-row w-full">
            <div className="border-primary-blue text-center text-primary-red md:border-r px-8 py-2 sm:!w-[280px] text-lg font-bold">
              कम्पनीको ठेगाना
            </div>
            <div className="border-primary-blue flex text-primary-red border-t md:border-t-0 w-full text-base font-bold sm:text-lg">
              <input
                className="outline-none w-full text-primary-blue p-2 "
                {...register(`company_address`, {
                  // required: false,
                })}
              />
            </div>
          </div>
          <div className="flex flex-col md:flex-row w-full">
            <div className="border-primary-blue  text-primary-red border-t md:border-r text-center px-5 py-2 md:w-[70.9rem] text-lg font-bold">
              दर्ता गर्ने प्रकृती (कुन कुनमा दर्ता गर्ने हो छनोट गर्नुहोस्)
            </div>

            <div className="flex flex-col md:flex-row border-primary-blue text-primary-red border-t gap-3 pl-5 w-full items-center text-base font-bold sm:text-lg">
              <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border px-3 py-0 text-white">
                <label htmlFor="pan" className="text-sm font">
                  {" "}
                  ONLY PAN{" "}
                </label>
                <input
                  type="radio"
                  name="radio-btn"
                  value="pan"
                  className="bg-yellow"
                  {...register("registration_nature", { required: false,
                    onChange: (e) => {setRegistrationNature(e.target.value)}
                  
                  })}
                  id="pan"
                />
              </div>
              <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border px-3 py-0 text-white">
                <label htmlFor="pan&vat" className="text-sm font">
                  {" "}
                  PAN & VAT
                </label>
                <input
                  type="radio"
                  name="radio-btn"
                  value="pan_vat"
                   {...register("registration_nature", { required: false, 
                    onChange: (e) => {setRegistrationNature(e.target.value)}
                  
                  })}
                  id="pan&vat"
                />
              </div>
              <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border px-3 py-0 text-white">
                <label htmlFor="pve" className="text-sm font">
                  PAN VAT & Excise
                </label>
                <input
                  type="radio"
                  name="radio-btn"
                  value="pan_vat_excise"
                   {...register("registration_nature", { required: false,
                    onChange: (e) => {setRegistrationNature(e.target.value)}    
                  })}
                  id="pve"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full flex gap-1 md:flex-row flex-col items-center">
        <div className="mt-4 border-2 border-primary-blue w-full">
            {/* <div> */}
            {Pan_Registration_v5.map((item, i) => {
              const { name, validation, ip1, type } = item;
              return (
               
                  <div
                    key={i}
                    className=" font-Laila border-primary-blue flex flex-col   md:flex-row  "
                  >
                    <div className="text-primary-red border-b text-center border-primary-blue px-5 py-2 sm:!w-[300px] font-bold">
                      {ip1}
                    </div>
                    <div className="md:border-l-2 border-b border-primary-blue text-primary-red  px-10 text-lg font-bold">
                      <input
                        type={type}
                        className=" w-full py-2 outline-none "
                        {...register(`${name}`, { required: false })}
                      />
                    </div>
                  </div>
               
              );
            })}

            {/* </div> */}
          <div className="bg-red-200 border-spacing-2 border-primary-blue font-Laila  border-t text-primary-blue font-bold   text-center">
            <div className="p-3">
              पुँजी र प्रकृतीको आधारमा तपाईको जम्मा लाग्ने रकम{" "}
              <span className="text-red-600">रु.{amount}!- </span> मात्र
            </div>
          </div>
        </div>
        <div>
          <div>
            <div className="border-primary-red text-primary-blue  text-center fot-Laila w-fit rounded-full border-2 p-2 text-sm md:text-base">
              प्रा.लि. कम्पनीको पान, भ्याट दर्ता गर्दा शुल्क लाग्ने सम्बन्धि
              पूर्ण जानकारी लिनको लागि यहाँ <span
                data-bs-toggle="modal"
                data-bs-target="#exampleModalEdit"
                className="text-primary-red cursor-pointer"
              >
                Click
              </span> गर्नुहोस ।
              <PrivateCompanyModal paymentRangeList={paymentRangeList} />
            </div>
          </div>
        </div>
      </div>
      <div className="text-primary-blue font-Calistoga text-lg my-3 underline">
        2. Details of Share Holders <span className="text-primary-blue underline">
          (कम्पनी दर्ता गर्दा रहेका शेयर सदस्यहरुको विवरण अनिवार्य भर्नुपर्नेछ
          ।)
        </span>
      </div>

      <DetailsOfShareHolders
        DetailShareholder={Pan_Reg_details_of_shareholder}
        needed_share={pan_shareholder}
        setShareHolders={setShareHolders}
        shareHolders={shareHolders}
      />

      <div className="text-primary-blue font-Calistoga text-lg my-3 underline">
        3. Main Objective
        <span className="text-primary-blue font-Laila underline">
          (पान प्रमाण पत्रमा देखिने गरी राख्नुपर्ने मुख्य मुख्य कामहरु सहितको
          उद्देश्यहरु यहाँ लेख्नुहोस्)
        </span>
      </div>
      <MainObjectives register={register} />
      <p className="text-primary-blue font-Calistoga text-lg  my-3 underline">
        4.Document Upload{" "}
      </p>
        <p className="text-primary-blue font-Laila">
          {" "}
          (यो पान, भ्याटमा दर्ताको लागि आवश्यक पर्ने निम्न कागजपत्रहरु{" "}
          <span className="text-red-600">Upload</span> गर्नुहोस ।)
        </p>
      <Documents
        documents_data={Vat_upload_details_v2}
        initialState={data}
        setDocument={setDocsOutput}
      />

      <div className="text-primary-blue font-Calistoga text-lg my-3 underline">
        5. Working Branch <span className="text-primary-blue font-Laila underline">
          (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा
          नजिक पर्छ छनोट गर्नुहोस् ।){" "}
        </span>
      </div>
      <FormBranch register={register} />
      <FormButtom />
      <FormPayment
        handleSubmit={handleSubmit}
        handleClick={handleClick}
        setUploadProof={setUploadProof}
        dueAmount = {dueAmount}
        setPaidAmount = {setPaidAmount}
        totalAmount={amount}

      />
    </form>

    // <div>test</div>

    // <form className="">

    //   <div className="flex justify-between">
    //     <p className="text-primary-red text-lg underline">
    //       1. Business Name & Other Details
    //     </p>
    //     <p className="text-primary-red flex">
    //       Firm No.
    //       <p className=" text-primary-blue"> 1234</p>
    //     </p>
    //   </div>

    //   {/* business and company details */}
    //   <div className="overflow-x-auto">
    //     <div>
    //       <div>
    //         <div className="flex">
    //           <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
    //             कम्पनीको नाम
    //           </div>

    //           <div className="border-primary-blue flex text-primary-red border px-20 text-base font-bold sm:text-lg">
    //             <p>नेपालीमा : </p>
    //             <input />
    //           </div>
    //           <div className="border-primary-blue flex text-primary-red border px-20 text-base font-bold sm:text-lg">
    //             <p>English मा : </p>
    //             <input />
    //           </div>
    //         </div>
    //         <div className="flex">
    //           <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
    //             कम्पनीको ठेगाना
    //           </div>
    //           <div className="border-primary-blue flex text-primary-red border px-20 text-base font-bold sm:text-lg">
    //             <input />
    //           </div>
    //         </div>
    //         <div className="flex">
    //           <div className="border-primary-blue text-primary-red border px-6 text-lg font-bold">
    //             ब्यवसायको प्रकार
    //           </div>
    //           <div className="flex border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-base">
    //             <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
    //               <label htmlFor="">एकल </label>
    //               <input type="radio" name="radio-btn" id="" />
    //             </div>
    //             <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
    //               <label htmlFor=""> साझेदारी</label>
    //               <input type="radio" name="radio-btn" id="" />
    //             </div>
    //           </div>
    //           <div className="flex border-primary-blue text-primary-red border px-6 text-base font-bold ">
    //             ब्यवसायको प्रकृती:m,,m
    //             <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
    //               <label htmlFor="">ONLY PAN </label>
    //               <input type="radio" name="radio-btn" id="" />
    //             </div>
    //             <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
    //               <label htmlFor="">PAN & VAT</label>
    //               <input type="radio" name="radio-btn" id="" />
    //             </div>
    //             <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
    //               <label htmlFor=""> PAN, VAT & EXCISE</label>
    //               <input type="radio" name="radio-btn" id="" />
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   {/* business and company details close*/}

    //   <div className="mt-4">
    //     <div>
    //       <div>
    //         {Pan_Registration_v2.map((item, i) => {
    //           const { name, validation, ip1, type } = item;
    //           console.log(item);
    //           return (
    //             <div
    //               key={i}
    //               className="border-primary-blue flex flex-col md:flex-row"
    //             >
    //               <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
    //                 {ip1}
    //               </div>
    //               <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
    //                 <input type={type} />
    //               </div>
    //             </div>
    //           );
    //         })}
    //       </div>
    //     </div>
    //   </div>

    //   <div className="mt-4">
    //     <div>
    //       <div>
    //         {Pan_Registration_v3.map((item, i) => {
    //           const { name, validation, ip1, type } = item;
    //           console.log(item);
    //           return (
    //             <div
    //               key={i}
    //               className="border-primary-blue flex flex-col md:flex-row"
    //             >
    //               <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
    //                 {ip1}
    //               </div>
    //               <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
    //                 <input type={type} />
    //               </div>
    //             </div>
    //           );
    //         })}
    //       </div>
    //     </div>
    //   </div>

    //   {/* share holder details form */}
    //   <div className="flex flex-col">
    //     <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
    //       <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
    //         <div className="min-w-[1300px] overflow-x-auto">
    //           <div id="tbl_posts">
    //             <div>
    //               <div>
    //                 <div className="border-primary-blue  text-primary-red border text-lg font-bold">
    //                   क्र. स.
    //                 </div>
    //                 <div className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
    //                   साझेदार सदस्यहरुको नाम
    //                 </div>
    //                 <div className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
    //                   हालको ठेगाना
    //                 </div>
    //                 <div className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
    //                   लगानी गर्ने शेयरको प्रतिशत
    //                 </div>
    //                 <div className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
    //                   लगानी गर्ने शेयर रकम
    //                 </div>

    //                 <div className="border-primary-blue text-primary-red border border-r-0 text-base font-bold sm:text-lg">
    //                   शेयर सदस्यको नागरिकता
    //                 </div>
    //                 <div className="border-primary-blue text-primary-red border border-r text-base font-bold sm:text-lg">
    //                   पासपोर्ट साईजको फोटो
    //                 </div>
    //               </div>
    //             </div>
    //             <div id="tbl_posts_body">
    //               <div id="rec-1" className="border-primary-blue border">
    //                 <div className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
    //                   1
    //                 </div>
    //                 <div className="p-0">
    //                   <input
    //                     type="text"
    //                     name=""
    //                     className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
    //                     id=""
    //                   />
    //                 </div>
    //                 <div className="p-0">
    //                   <input
    //                     type="text"
    //                     name=""
    //                     className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
    //                     id=""
    //                   />
    //                 </div>
    //                 <div className="p-0">
    //                   <input
    //                     type="text"
    //                     name=""
    //                     className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
    //                     id=""
    //                   />
    //                 </div>
    //                 <div className="p-0">
    //                   <input
    //                     type="text"
    //                     name=""
    //                     className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
    //                     id=""
    //                   />
    //                 </div>
    //                 <div className="p-0">
    //                   <input
    //                     type="file"
    //                     name=""
    //                     className="border-primary-blue file:bg-primary-blue h-[54px] w-full cursor-pointer border-r py-3 px-3 outline-none file:rounded-2xl file:text-white"
    //                     id=""
    //                   />
    //                 </div>

    //                 <div className="p-0">
    //                   <input
    //                     type="file"
    //                     name=""
    //                     className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer py-3 px-3 outline-none file:rounded-2xl file:text-white"
    //                     id=""
    //                   />
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //           <div style={{ display: "none" }}>
    //             {/* div row add */}
    //             <div id="sample_table">
    //               <div>
    //                 <div id="" className="border-primary-blue border">
    //                   <div className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
    //                     <span className="sn">1</span>
    //                   </div>
    //                   <div className="p-0">
    //                     <input
    //                       type="text"
    //                       name=""
    //                       className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
    //                       id=""
    //                     />
    //                   </div>
    //                   <div className="p-0">
    //                     <input
    //                       type="text"
    //                       name=""
    //                       className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
    //                       id=""
    //                     />
    //                   </div>
    //                   <div className="p-0">
    //                     <input
    //                       type="text"
    //                       name=""
    //                       className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
    //                       id=""
    //                     />
    //                   </div>
    //                   <div className="p-0">
    //                     <input
    //                       type="file"
    //                       name=""
    //                       className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer border-r py-3 px-3 outline-none file:rounded-2xl file:text-white"
    //                       id=""
    //                     />
    //                   </div>
    //                   <div className="p-0">
    //                     <input
    //                       type="text"
    //                       name=""
    //                       className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
    //                       id=""
    //                     />
    //                   </div>
    //                   <div className="p-0">
    //                     <input
    //                       type="text"
    //                       name=""
    //                       className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
    //                       id=""
    //                     />
    //                   </div>
    //                   <div className="p-0">
    //                     <input
    //                       type="file"
    //                       name=""
    //                       className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer py-3 px-3 outline-none file:rounded-2xl file:text-white"
    //                       id=""
    //                     />
    //                   </div>
    //                   <div className="">
    //                     <a href="" className="delete-record">
    //                       <svg
    //                         className="text-primary-red h-8 w-8"
    //                         xmlns="http://www.w3.org/2000/svg"
    //                         aria-hidden="true"
    //                         role="img"
    //                         preserveAspectRatio="xMidYMid meet"
    //                         viewBox="0 0 24 24"
    //                       >
    //                         <path
    //                           fill="currentColor"
    //                           d="M19.1 4.9C15.2 1 8.8 1 4.9 4.9S1 15.2 4.9 19.1s10.2 3.9 14.1 0s4-10.3.1-14.2zm-4.3 11.3L12 13.4l-2.8 2.8l-1.4-1.4l2.8-2.8l-2.8-2.8l1.4-1.4l2.8 2.8l2.8-2.8l1.4 1.4l-2.8 2.8l2.8 2.8l-1.4 1.4z"
    //                         />
    //                       </svg>
    //                     </a>
    //                   </div>
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   {/* details of share holders close */}

    //   <MainObjectives />

    //   {/* upload documents open */}
    //   <div>
    //     <div>
    //       <div>
    //         <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
    //           S. N.
    //         </div>
    //         <div className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
    //           Document Name
    //         </div>
    //         <div className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
    //           Action
    //         </div>
    //         <div className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
    //           Remarks
    //         </div>
    //       </div>
    //     </div>
    //     <div>
    //       {Vat_upload_details.map((item, index) => {
    //         return (
    //           <div className="border-primary-blue border">
    //             <div className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
    //               {item.sn}
    //             </div>
    //             <div className="p-0">
    //               <p className="border-primary-blue text-primary-blue font-semibold m-0 h-[54px] w-full border-r py-3 px-3 outline-none">
    //                 {item.ip1}
    //                 <button className="bg-primary-blue text-white rounded-xl ml-3 px-2">
    //                   Upload
    //                 </button>
    //               </p>
    //             </div>
    //             <div className="p-0">
    //               <div className="border-primary-blue text-white m-0 h-[54px] w-full border-r py-3 px-3 outline-none space-x-2">
    //                 <button className="bg-primary-green rounded-xl px-2 ">
    //                   view
    //                 </button>
    //                 <button className="bg-primary-red rounded-xl px-2">
    //                   Delete
    //                 </button>
    //               </div>
    //             </div>
    //             <div className="p-0">
    //               <div className="border-primary-blue text-primary-blue font-semibold m-0 h-[54px] w-full border-r py-3 px-3 outline-none space-x-2">
    //                 {item.remark}
    //               </div>
    //             </div>
    //           </div>
    //         );
    //       })}
    //     </div>
    //   </div>
    //   {/* upload documents close */}
    //   <FormBranch />
    //   <FormButtom />
    // </form>
  );
};

export default VatRegistrationA;
